module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/conditioner@2x_a9cfb9.png";